export default __webpack_public_path__ + "static/media/IMG_7605.4211e6d0.jpeg";